import Loader from '@betterfunnel/ui-core/Loader';
import { useContext, useMemo } from 'react';
import AdsAccountTree, {
    DynamicPageMetadata,
} from '../../components/AdsAccountTree/AdsAccountTree';
import { DashboardContext } from '../../contexts/DashboardContext';
import { DynamicPageContext } from '../../contexts/DynamicPageContext';

export default function ManageDynamicPageAdsMap() {
  const { selectedDynamicPage } = useContext(DashboardContext);
  const { variants, primaryDomain } = useContext(DynamicPageContext);

  const requestId = useMemo(() => {
    return selectedDynamicPage?.id;
  }, [selectedDynamicPage]);

  const linkedCampaignsToDynamicPage = useMemo(() => {
    const connections = selectedDynamicPage?.data().connections;
    if (!connections) {
      return [];
    }
    return Object.values(connections).filter((c) => c.type === 'adsCampaign');
  }, [selectedDynamicPage]);

  const adsMapConfig = useMemo(() => {
    if (
      !linkedCampaignsToDynamicPage.length ||
      !requestId ||
      !selectedDynamicPage
    ) {
      return null;
    }
    return {
      requestId,
      adsAccountId: linkedCampaignsToDynamicPage[0].adsAccountId,
      campaignIds: linkedCampaignsToDynamicPage
        // currently we only support fetching campaigns from the same account
        .filter((c) => {
          return (
            c.adsAccountId === linkedCampaignsToDynamicPage[0].adsAccountId
          );
        })
        .map((campaign) => campaign.id),
      dynamicPages: [
        {
          id: selectedDynamicPage.id,
          name: selectedDynamicPage.data().name,
          description: selectedDynamicPage.data().description,
          domain: primaryDomain?.data().domain ?? '',
          path: selectedDynamicPage.data().path,
          variants:
            variants?.map((variant) => ({
              id: variant.id,
              ...variant.data(),
            })) || [],
        } satisfies DynamicPageMetadata,
      ],
    };
  }, [
    linkedCampaignsToDynamicPage,
    primaryDomain,
    requestId,
    selectedDynamicPage,
    variants,
  ]);

  if (!variants || !selectedDynamicPage) {
    return (
      <div className="flex w-full justify-center pt-24">
        <Loader />
      </div>
    );
  }

  if (!linkedCampaignsToDynamicPage.length) {
    return (
      <div className="flex h-full min-h-64 items-center justify-center">
        <p className="text-center text-gray-500">
          No campaigns linked to this dynamic page
        </p>
      </div>
    );
  }

  return (
    <div className="relative h-full w-full flex-1">
      <div className="absolute inset-0">
        {adsMapConfig && (
          <AdsAccountTree
            requestId={adsMapConfig.requestId}
            adsAccountId={adsMapConfig.adsAccountId}
            campaignIds={adsMapConfig.campaignIds}
            dynamicPages={adsMapConfig.dynamicPages}
          />
        )}
      </div>
    </div>
  );
}
